var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgS = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "5.25rem",
  height: "6rem",
  "data-name": "Group 40",
  viewBox: "0 0 209.372 169.688"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "S_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h209.372v169.688H0z",
  "data-name": "Rectangle 35",
  style: {
    fill: "none"
  }
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 39",
  style: {
    clipPath: "url(#S_svg__a)"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M204.646 137.6H4.727v.321A31.77 31.77 0 0 0 36.5 169.688h136.374a31.77 31.77 0 0 0 31.772-31.772z",
  "data-name": "Path 123"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M196.646 95.4H12.727A7.726 7.726 0 0 0 5 103.125v15.452a7.726 7.726 0 0 0 7.726 7.726h183.92a7.726 7.726 0 0 0 7.726-7.726v-15.452a7.726 7.726 0 0 0-7.726-7.726",
  "data-name": "Path 124"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M199.463 63.514H9.909A4.91 4.91 0 0 0 5 68.423v10.293a4.91 4.91 0 0 0 4.909 4.909h189.554a4.91 4.91 0 0 0 4.909-4.909V68.423a4.91 4.91 0 0 0-4.909-4.909",
  "data-name": "Path 125"
})), /*#__PURE__*/React.createElement("rect", {
  width: 204.372,
  height: 16.886,
  "data-name": "Rectangle 34",
  rx: 8.384,
  style: {
    fill: "#fff"
  },
  transform: "translate(2.5 123.209)"
}), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M198.489 125.709a5.884 5.884 0 0 1 5.884 5.884v.119a5.884 5.884 0 0 1-5.884 5.883H10.884A5.883 5.883 0 0 1 5 131.712v-.119a5.884 5.884 0 0 1 5.884-5.884zm0-5H10.884A10.9 10.9 0 0 0 0 131.593v.119A10.9 10.9 0 0 0 10.884 142.6h187.6a10.9 10.9 0 0 0 10.884-10.883v-.119a10.9 10.9 0 0 0-10.884-10.884",
  "data-name": "Path 126"
})), /*#__PURE__*/React.createElement("path", {
  d: "M63.532 120.617a13.76 13.76 0 0 1-13.744-13.744v-.227a8.754 8.754 0 0 0-8.744-8.746h-30.16A8.393 8.393 0 0 1 2.5 89.518V89.4a8.393 8.393 0 0 1 8.384-8.384h187.6a8.393 8.393 0 0 1 8.384 8.384v.119a8.393 8.393 0 0 1-8.384 8.384H91.266a8.754 8.754 0 0 0-8.744 8.744v.227a13.76 13.76 0 0 1-13.744 13.744z",
  "data-name": "Path 127",
  style: {
    fill: "#fff"
  }
}), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M198.489 83.515a5.884 5.884 0 0 1 5.884 5.884v.119a5.884 5.884 0 0 1-5.884 5.883H91.267a11.244 11.244 0 0 0-11.244 11.244v.228a11.244 11.244 0 0 1-11.244 11.244h-5.246a11.244 11.244 0 0 1-11.244-11.244v-.228A11.245 11.245 0 0 0 41.044 95.4h-30.16A5.883 5.883 0 0 1 5 89.518V89.4a5.884 5.884 0 0 1 5.884-5.884zm0-5H10.884A10.9 10.9 0 0 0 0 89.4v.119A10.9 10.9 0 0 0 10.884 100.4h30.16a6.25 6.25 0 0 1 6.245 6.244v.228a16.26 16.26 0 0 0 16.244 16.244h5.246a16.26 16.26 0 0 0 16.244-16.244v-.228a6.25 6.25 0 0 1 6.244-6.244h107.222a10.9 10.9 0 0 0 10.884-10.883V89.4a10.9 10.9 0 0 0-10.884-10.884",
  "data-name": "Path 128"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m146.784 160.968-32.457-32.457h64.914z",
  "data-name": "Path 129"
})), /*#__PURE__*/React.createElement("path", {
  d: "M146.783 163.469a2.5 2.5 0 0 1-1.768-.733l-32.456-32.456a2.5 2.5 0 0 1 1.768-4.268h64.913a2.5 2.5 0 0 1 1.768 4.268l-32.458 32.456a2.5 2.5 0 0 1-1.767.733m-26.421-32.457 26.421 26.421 26.422-26.421z",
  "data-name": "Path 130",
  style: {
    fill: "#fff"
  }
}), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M199.163 59.3a3.563 3.563 0 0 0 3.016-5.457 115.924 115.924 0 0 0-195.794 0A3.563 3.563 0 0 0 9.4 59.3z",
  "data-name": "Path 131"
})), /*#__PURE__*/React.createElement("path", {
  d: "M201.876 59.3H7.021a2.375 2.375 0 0 0-2.375 2.375v.048A2.375 2.375 0 0 0 7.021 64.1h194.855a2.375 2.375 0 0 0 2.375-2.375v-.048a2.375 2.375 0 0 0-2.375-2.375",
  "data-name": "Path 132",
  style: {
    fill: "#fff"
  }
})));
export default SvgS;